(function($) {
	$(document).ready(function(){
		$('.modal-button').each(function(){
			var $this = $(this);
			var id = $this.attr('data-modal-id');
			$this.click(function(e){
				e.preventDefault();
				$('#modal-' + id).addClass('show');
				window.scrollTo(0,0);
				$('body').addClass('disable-scroll');
			});
		});

		$('p.menu-close').click(function(){
			$('.menu-overlay.show').removeClass('show');
			$('body').removeClass('disable-scroll');
		});

	});
})(jQuery); // Fully reference jQuery after this point.